<section class="sub-section">

    <div class="container">

        <h3 class="sub-section__title" *ngIf="section?.title">{{ section?.title }}</h3>

        <mlp-ng-sub-nav 
            [links]="nav$ | async" 
            class="d-md-inline-block text-right text-md-left" 
            (toggleDropdown)="toggleDropdown($event)"></mlp-ng-sub-nav>

    </div>

    <mlp-ng-nav-dropdown
        (linkClicked)="closeAll()"
        [ngClass]="{ 'd-md-none': !section.subNavLinks }"
        class="sub-section__dropdown" 
        [links]="(section.subNavLinks) ? section.subNavLinks : section.nav.mainLinks" 
        *ngIf="showDropdown"></mlp-ng-nav-dropdown>

</section>
